import type React from 'react';
import lazyLoad from '@/primitives/lazy.load.tsx';

const LazySubscription = lazyLoad(() => import('./Subscription'));

export const subscriptionRoute = {
  path: '/subscription',
  element: <Subscription />,
};

export default function Subscription(
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) {
  return <LazySubscription {...props} />;
}
